var env = "PROD01";
var API_BASE_URL = "";
var WEB_SOCKET_BASE_URL = "";

if (env === "DEV") {
    API_BASE_URL = 'http://localhost:8400/auth'; 
    WEB_SOCKET_BASE_URL = 'ws://localhost:8400/auth';
} else if (env=="TEST01") {
    API_BASE_URL = 'https://test-po2rfms.eaglepointsol.com/auth';
    WEB_SOCKET_BASE_URL = 'wss://test-po2rfms.eaglepointsol.com/auth';
} else if (env=="PROD01"){
    API_BASE_URL = 'https://po2rfms.eaglepointsol.com/auth';
    WEB_SOCKET_BASE_URL = 'wss://po2rfms.eaglepointsol.com/auth';
}
else {
    API_BASE_URL = 'https://eaglepoint.wpbrigade.com/auth';
    WEB_SOCKET_BASE_URL = 'wss://eaglepoint.wpbrigade.com/auth';   
}

export { API_BASE_URL, WEB_SOCKET_BASE_URL };
